





























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';

const LinkSessionMutation = gql`
  mutation LinkSession($centerId: ID!, $lane: Int!, $position: Int!, $bowlerName: String) {
    linkUserToBowlingSession(centerId: $centerId, lane: $lane, position: $position,
      bowlerName: $bowlerName)
  }
`;

@Component({
  components: {
  },
})
export default class LinkSession extends Vue {
  @Prop({ required: true, type: String })
  public centerId!: string;

  @Prop({ required: true, type: Number })
  public lane!: number;

  @Prop({ required: false, type: String, default: '' })
  public currentName!: string;

  public position: number | null = null;
  public bowlingName = this.currentName;
  public user: any = null;

  public error: string | null = null;
  public loading: boolean = false;

  public linkSession() {
    if (!this.bowlingName || !this.position) {
      this.error = 'Your bowling name and position are both required.';
      return;
    }

    this.loading = true;
    this.$apollo.mutate({
      mutation: LinkSessionMutation,
      variables: {
        centerId: this.centerId,
        lane: this.lane,
        position: this.position,
        bowlerName: this.bowlingName,
      },
    }).then((r) => {
      this.loading = false;
      this.$emit('sessionLinked');
    }).catch((e) => {
      this.loading = false;
      this.error = parseError(e) || UNKNOWN_ERROR;
    });
  }
}
